import React, { Fragment } from "react";
import Header from "../../components/HomeComponents/Header/Header";
import HeroSection from "../../components/HomeComponents/Hero-Section/HeroSection";
import Courses from "../../components/HomeComponents/Courses-section/Courses";
import { Box } from "@mui/material";
import FreeCourse from "../../components/HomeComponents/Free-course-section/FreeCourse";
import Features from "../../components/HomeComponents/Feature-section/Features";
import Testimonials from "../../components/HomeComponents/Testimonial/Testimonials";
import ChooseUs from "../../components/HomeComponents/Choose-us/ChooseUs";
import StudyPackSection from "../../components/HomeComponents/Study-pack-section/StudyPackSection";
import { ToastContainer } from "react-toastify";
import Footer from "../../components/footer/Footer";

const Home = () => {
  return (
    <Fragment>
       <ToastContainer />
      <Box
        component="div"
        sx={{
          height: "100%",
          width: "100%",
          zIndex: -1,
          backgroundRepeat: "repeat",
          backgroundImage: `url(${"https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2Fbackground.png?alt=media&token=a9467179-4448-456a-9892-de49d2eef4b7"})`,
          objectPosition: "left",
          backgroundPosition: "center",
        }}
        alt="random"
      >
        <Header />
        <HeroSection />

        {/* <CompanySection /> */}
        {/* <AboutUs /> */}
        <Courses />
        <StudyPackSection />
        {/* <ChooseUs/> */}
        {/* <Features />
      <FreeCourse /> */}
        {/* <Testimonials /> */}
        {/* <Footer /> */}
      </Box>
      <Footer />
    </Fragment>
  );
};

export default Home;
